import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/content';

interface NewsCardProps {
  news: NewsItem;
}

export default function NewsCard({ news }: NewsCardProps) {
  return (
    <Link
      to={`/news/${news.id}`}
      className="group flex gap-3 md:gap-4 rounded-lg border border-background-200 bg-background-50 p-3 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-28 h-20 md:w-44 md:h-[104px] rounded-md overflow-hidden shrink-0 bg-background-200">
        <img
          src={news.cover}
          alt={`女友的妈妈 影视资讯 ${news.title} 封面`}
          title={`${news.title} 女友的妈妈 影视资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="min-w-0 flex flex-col justify-between py-0.5">
        <div>
          <div className="flex items-center gap-2 mb-1.5">
            <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] whitespace-nowrap">
              {news.category}
            </span>
            <span className="text-[11px] text-foreground-400 hidden sm:inline">{news.date}</span>
          </div>
          <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
            {news.title}
          </h3>
          <p className="hidden md:block text-xs md:text-sm text-foreground-600 leading-relaxed mt-1.5 line-clamp-2">
            {news.summary}
          </p>
        </div>
        <p className="sm:hidden text-[11px] text-foreground-400 mt-1">{news.date}</p>
      </div>
    </Link>
  );
}